// PLACE HOLDER FILE UNTIL WE MIGRATE TRANSACTIONS TO BACKEND!!
import axios from 'axios';

export const baseAPIFactory = (prefix) => {

    const transactions = axios.create({
        // if there is no origin in the url passed into the first arg i believe axios just pre-pends the front end origin?
        // which is why this works because you are always just grabbing from the machine with everything else?
        baseURL: prefix
    })


    return {
        transactions,
    }

}

// additional exported xxxBaseAPIs, with different prefix for different route group on backend